module.exports = __webpack_public_path__ + "img/tupian.4f9da734.png";